// CORE-1735 slice 17 (D-120, QA V06) — Live icon «hand» from the published set v4.2
// (Confluence 110461314, archive reference-icons-v4.2): geometry as shipped, strokes 1.8,
// paint from the caller (`color` — solid or an ink gradient reference), the inner
// highlight through `filter` (the toolbar's «live-polish»), the slash cut by `cut`.
import React from 'react';
import Svg, { G, Path } from 'react-native-svg';
import type { LiveGlyphProps } from '../types';

export const Hand: React.FC<LiveGlyphProps> = ({ size, color, filter }) => (
  <Svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <G filter={filter} fill={color} fillRule="evenodd">
    <Path d="M6 12V6a1.3 1.3 0 0 1 2.6 0v5H9V3.5a1.3 1.3 0 0 1 2.6 0V11h.5V2a1.3 1.3 0 0 1 2.6 0v9h.5V5a1.3 1.3 0 0 1 2.6 0v9l1.7-2a1.5 1.5 0 0 1 2.4 1.8l-4 6.3a6 6 0 0 1-5 2.9H11a6 6 0 0 1-5-3l-3-5a1.5 1.5 0 0 1 2.4-1.8L6 14Z" fill={color} />
    </G>
  </Svg>
);
